import { render } from "./ComoAjudar.vue?vue&type=template&id=01a94cf5"
import script from "./ComoAjudar.vue?vue&type=script&lang=js"
export * from "./ComoAjudar.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__